var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#864e20}.c{fill:#e7c930}"))), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 7.656,
    style: {
      fill: "#f8de40"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.907 8.275a.182.182 0 0 0-.331-.1 2.016 2.016 0 0 1-.569.567 1.728 1.728 0 0 1-1.915 0 2.029 2.029 0 0 1-.571-.569.182.182 0 0 0-.331.1 1.63 1.63 0 0 0 .346 1.022 1.926 1.926 0 0 0 3.026 0 1.636 1.636 0 0 0 .345-1.02zM18.81 8.275a.182.182 0 0 0-.331-.1 2.026 2.026 0 0 1-.568.567 1.73 1.73 0 0 1-1.916 0 2.029 2.029 0 0 1-.571-.569.182.182 0 0 0-.331.1 1.63 1.63 0 0 0 .346 1.022 1.926 1.926 0 0 0 3.026 0 1.636 1.636 0 0 0 .345-1.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23 13.938a14.69 14.69 0 0 1-12.406 6.531c-5.542 0-6.563-1-9.142-2.529A7.66 7.66 0 0 0 8.656 23h6.688A7.656 7.656 0 0 0 23 15.344z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.633 12.993A7.322 7.322 0 0 1 12 14.044a7.322 7.322 0 0 1-3.633-1.051c-.363-.241-.478-.215-.478-.129 0 1.056 2.055 1.708 4.111 1.708s4.111-.652 4.111-1.708c0-.086-.111-.112-.478.129z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.136 15.183a2.262 2.262 0 0 1-2.272 0c-.268-.2-.252.381.341.536a2.786 2.786 0 0 0 .8.172 2.786 2.786 0 0 0 .8-.172c.583-.155.595-.739.331-.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaceIcon);
export default __webpack_public_path__ + "static/media/peace-icon.8ca7e2002fbc6693cafa0ed765a306b5.svg";
export { ForwardRef as ReactComponent };